<tpm-dialog-frame
  alt-theme
  [header]="data?.headline | translate"
  [closable]="true"
>
    <video-player [source]="data?.media" [title]="data?.headline | translate"></video-player>
    <p class="cta-sm date-description">
      {{ data.date | date : "dd.MM.yyyy" }}
    </p>
    <p class="body-sm">
      {{ data.teaser }}
    </p>
</tpm-dialog-frame>
